var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"font-weight-bold"},[_c('CIcon',{attrs:{"name":"cilChatBubble"}}),_vm._v(" Danh sách Ghé Thăm "),_c('a',{attrs:{"href":"javascript:","title":"Tạo ghé thăm cho KH này"},on:{"click":function($event){_vm.isCreating = true;
        _vm.isCare = false;}}},[_c('CIcon',{attrs:{"name":"cil-plus","custom-classes":"c-icon c-icon-lg text-success"}})],1),_vm._v(" và Chăm Sóc "),_c('a',{attrs:{"href":"javascript:","title":"Tạo CSKH cho KH này"},on:{"click":function($event){_vm.isCreating = true;
        _vm.isCare = true;}}},[_c('CIcon',{attrs:{"name":"cil-plus","custom-classes":"c-icon c-icon-lg text-warning"}})],1)],1),_c('odata-table',{ref:"lstCustVisit",attrs:{"url":"odata/CustomerVisit","filter":_vm.filter,"expand":"Product($select=Name), Agency($select=Name), Orders($count=true;$top=0)","sortBy":"CreatedAt desc","onData":_vm.processData,"pageSize":_vm.pageSize,"colSetting":{
      Action: {
        field: '',
        display: 'Thao tác',
        sortable: false,
        style: 'min-width: 50px',
      },
      CreatedAt: {
        field: 'CreatedAt',
        display: 'Ngày ghé',
        sortable: true,
        style: 'min-width: 150px',
      },
      BuyingExp: {
        field: 'BuyingExp',
        display: 'Trải nghiệm',
        sortable: true,
        style: 'min-width: 100px',
      },
      Source: {
        field: 'Source',
        display: 'Kênh liên hệ',
        sortable: true,
        style: 'min-width: 120px',
      },
      Interest: {
        field: 'Interest',
        display: 'Quan tâm',
        sortable: true,
        style: 'min-width: 120px',
      },
      Comments: {
        field: 'Comments',
        display: 'Nhận định',
        sortable: true,
        style: 'min-width: 120px',
      },
      Product: {
        field: 'Product',
        display: 'Sản phẩm',
        sortable: true,
        style: 'min-width: 120px',
      },
      PriceRange: {
        field: 'PriceRange',
        display: 'Mức giá quan tâm',
        sortable: true,
        style: 'min-width: 120px',
      },
      NextStep: {
        field: 'NextStep',
        display: 'Kết quả ghé thăm',
        sortable: true,
        style: 'min-width: 120px',
      },
      Note: {
        field: 'Note',
        display: 'Ghi chú',
        sortable: true,
        style: 'min-width: 120px',
      },
      CreatedByName: {
        field: 'CreatedByName',
        display: 'Nhân viên',
        sortable: false,
        style: 'min-width: 100px',
      },
      Agency: {
        field: 'Agency/Name',
        display: 'Cửa hàng',
        sortable: true,
        style: 'min-width: 120px',
      },
      SaleProgram: {
        field: 'SaleProgram',
        display: 'Chương trình QC',
        sortable: true,
        style: 'min-width: 120px',
      },
      KOL: {
        field: 'KOL',
        display: 'KOL',
        sortable: true,
        style: 'min-width: 120px',
      },
      Advertise: {
        field: 'Advertise',
        display: 'ID Quảng cáo',
        sortable: true,
        style: 'min-width: 120px',
      },
      AdEvent: {
        field: 'AdEvent',
        display: 'Sự kiện QC',
        sortable: true,
        style: 'min-width: 120px',
      },
    }},scopedSlots:_vm._u([{key:"tbody",fn:function(ref){
    var rows = ref.rows;
return _vm._l((rows),function(row,i){return _c('tr',{key:("tr-" + i),style:(row.IsCare ? "background-color: #fcfcaa" : '')},[_c('td',{staticStyle:{"max-width":"50px"}},[(!row['Orders@odata.count'] && rows.length > 1)?_c('a',{staticClass:"text-danger",attrs:{"href":"javascript:"},on:{"click":function($event){return _vm.deleteCustomerVisit(row)}}},[_c('CIcon',{attrs:{"name":"cil-trash"}})],1):_vm._e()]),_c('td',[_vm._v(" "+_vm._s(_vm.$moment .utc(row.CreatedAt) .local() .format("DD/MM/YY HH:mm"))+" ")]),_c('td',{staticStyle:{"max-width":"100px"}},[(row.BuyingExp)?_c('span',[_vm._v(_vm._s(_vm.$const.BUYING_EXPERIENCES_TEXT[row.BuyingExp]))]):_vm._e()]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[(_vm.isAdmin)?_c('a',{attrs:{"href":"javascript:","title":"Sửa"},on:{"click":function($event){_vm.editingRow = row;
              _vm.editingSource = row.Source;
              _vm.editingNextStep = JSON.parse(row.Details).NextStep;
              _vm.editingBuyingExp = row.BuyingExp;
              _vm.isEditing = true;}}},[_c('CIcon',{attrs:{"name":"cil-pencil"}})],1):_vm._e(),_c('span',{class:{ 'text-warning': row.CreatedBy != row.UpdatedBy },attrs:{"title":_vm.getDetails(row, 'Source')}},[_vm._v(" "+_vm._s(_vm.getDetails(row, "Source"))+" ")])]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":_vm.getDetails(row, 'Interest')}},[_vm._v(_vm._s(_vm.getDetails(row, "Interest")))])]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":_vm.getDetails(row, 'Comments')}},[_vm._v(_vm._s(_vm.getDetails(row, "Comments")))])]),(row.Product)?_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":row.Product.Name}},[_vm._v(_vm._s(row.Product.Name))])]):_c('td'),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":_vm.getDetails(row, 'PriceRange')}},[_vm._v(_vm._s(_vm.getDetails(row, "PriceRange")))])]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":_vm.getDetails(row, 'NextStep')}},[_vm._v(_vm._s(_vm.getDetails(row, "NextStep")))])]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":row.Note}},[_vm._v(_vm._s(row.Note))])]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"100px"}},[(row.CreatedByName)?_c('span',{attrs:{"title":row.CreatedByName}},[_vm._v(" "+_vm._s(row.CreatedByName)+" ")]):_vm._e()]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[(row.Agency)?_c('span',{attrs:{"title":row.Agency.Name}},[_vm._v(" "+_vm._s(row.Agency.Name)+" ")]):_vm._e()]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":_vm.getDetails(row, 'SaleProgram')}},[_vm._v(" "+_vm._s(_vm.getDetails(row, "SaleProgram"))+" ")])]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":_vm.getDetails(row, 'KOL')}},[_vm._v(" "+_vm._s(_vm.getDetails(row, "KOL"))+" ")])]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":((row.AdGroup) + " " + (row.Advertise))}},[_vm._v(" "+_vm._s(row.AdGroup)+" "+_vm._s(row.Advertise)+" ")])]),_c('td',{staticClass:"text-truncate",staticStyle:{"max-width":"120px"}},[_c('span',{attrs:{"title":_vm.getDetails(row, 'AdEvent')}},[_vm._v(" "+_vm._s(_vm.getDetails(row, "AdEvent"))+" ")])])])})}}])}),_c('CModal',{attrs:{"title":"Sửa ghé thăm/chăm sóc","show":_vm.isEditing,"size":"sm","centered":""},on:{"update:show":function($event){_vm.isEditing=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('CButton',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.saving},on:{"click":function($event){return _vm.saveCustomerVisit(
            _vm.editingRow,
            _vm.editingBuyingExp,
            _vm.editingSource,
            _vm.editingNextStep
          )}}},[_c('CIcon',{attrs:{"name":"cil-save"}}),_vm._v(" Lưu ")],1),(_vm.saving)?_c('div',{staticClass:"d-inline-block font-italic"},[_c('CSpinner',{staticClass:"ml-2",attrs:{"color":"info","size":"sm"}}),_vm._v(" Đang xử lý... ")],1):_vm._e()]},proxy:true}])},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('CSelect',{attrs:{"label":"Trải nghiệm","placeholder":"Trải nghiệm","value":_vm.editingBuyingExp,"options":Object.keys(_vm.$const.BUYING_EXPERIENCES_TEXT).map(function (_) {
              return {
                value: _,
                label: _vm.$const.BUYING_EXPERIENCES_TEXT[_],
              };
            })},on:{"update:value":function($event){_vm.editingBuyingExp=$event}}})],1),_c('div',{staticClass:"col-md-12"},[_c('CSelect',{attrs:{"label":"Kênh liên hệ","placeholder":"Kênh liên hệ","value":_vm.editingSource,"options":_vm.miscs
              .filter(
                function (m) { return m.Type == 'Source' && m.Status == _vm.$const.STATUS.Active; }
              )
              .map(function (_) {
                return {
                  value: _.Value,
                  label: _.Text,
                };
              })},on:{"update:value":function($event){_vm.editingSource=$event}}})],1),_c('div',{staticClass:"col-md-12"},[_c('CSelect',{attrs:{"label":"KQ ghé thăm","placeholder":"KQ ghé thăm","value":_vm.editingNextStep,"options":_vm.miscs
              .filter(
                function (m) { return m.Type == 'NextStep' && m.Status == _vm.$const.STATUS.Active; }
              )
              .map(function (_) {
                return {
                  value: _.Value,
                  label: _.Text,
                };
              })},on:{"update:value":function($event){_vm.editingNextStep=$event}}})],1)])]),_c('CModal',{attrs:{"show":_vm.isCreating,"size":"xl","title":_vm.isCare ? 'Thêm CSKH' : 'Thêm Ghé Thăm',"centered":""},on:{"update:show":function($event){_vm.isCreating=$event}},scopedSlots:_vm._u([{key:"body-wrapper",fn:function(){return [_c('div',{staticClass:"modal-body overflow-auto",staticStyle:{"max-height":"calc(100vh - 10rem)"}},[_c('customer-visit',{attrs:{"isCare":_vm.isCare,"customerId":_vm.customerId},on:{"close":function($event){_vm.isCreating = false;
            _vm.$refs.lstCustVisit.loadData();}}})],1)]},proxy:true},{key:"footer-wrapper",fn:function(){return [_c('div')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }